import { render, staticRenderFns } from "./TeachersGroup.vue?vue&type=template&id=131331bb"
import script from "./TeachersGroup.vue?vue&type=script&lang=js"
export * from "./TeachersGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports